import {ClientOfferAtRiskFilterValue, ClientOfferAtRiskPageAction} from "./ClientOfferAtRiskPage";
import React, {Dispatch} from "react";
import {formatDate} from "common/util/date";
import CancelIcon from "@material-ui/icons/Cancel";
import {SPLIT_DELIMITER} from "../../../placement/const";

type ClientOfferAtRiskFilterBadgeProps = {
    filter: ClientOfferAtRiskFilterValue;
    dispatch: Dispatch<ClientOfferAtRiskPageAction>;
}
const ClientOfferAtRiskFilterBadge = ({filter, dispatch}: ClientOfferAtRiskFilterBadgeProps) => {
    let values: Array<string> = [];
    if (filter.fromDate) {
        values = values.concat(`Response Due Date From: ${formatDate(filter.fromDate)}`);
    }

    if (filter.toDate) {
        values = values.concat(`Response Due Date To: ${formatDate(filter.toDate)}`);
    }

    if (filter.cities) {
        values = values
            .concat(filter.cities.split(SPLIT_DELIMITER))
            .filter((val) => val !== '');
    }

    if (values.length === 0) {
        return <div/>;
    }

    const updateFilterByRemoveValue = (value: string) => {
        if (value) {
            if (value.includes("Response Due Date From:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, fromDate: null}});
                return;
            }
            if (value.includes("Response Due Date To:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, toDate: null}});
                return;
            }

            const cityList = filter.cities.split(SPLIT_DELIMITER)
            if (cityList.includes(value)) {
                const newCityList = cityList.filter((val) => val !== value).join(SPLIT_DELIMITER);
                dispatch({type: 'SET_FILTER', filter: {...filter, cities: newCityList}})
            }
        }

    }

    return (
        <div className='flex pl-5 items-start'>
            <div className='pt-2 pr-5 flex-grow-0'>
                Filter:
            </div>
            <div className='flex flex-grow flex-wrap'>
                {
                    values.map((value) => (
                        <div key={value}
                             className='mr-2 mb-2 bg-botticelli-100 text-white p-2 rounded leading-none flex items-center'>
                            {value}
                            <button className='bg-transparent outline-none focus:outline-none'
                                    onClick={() => updateFilterByRemoveValue(value)}>
                                <div
                                    className='bg-transparent text-white opacity-5 ml-3 outline-none focus:outline-none flex items-center'>
                                    <CancelIcon fontSize={"small"}/>
                                </div>
                            </button>
                        </div>
                    ))
                }
            </div>
        </div>);
}

export default ClientOfferAtRiskFilterBadge;